module.exports = __webpack_public_path__ + "src/images/googlePlay.png";